// extracted by mini-css-extract-plugin
export default {"link":"FooterLink__link___EwYoR"};